import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ViewTradingServices from '../../services/ViewTradingServices';
import DeleteButton from './Button/DeleteButton';
import Modal from 'react-modal';
import WebhookUpdate from './Update Model/WebhookUpdate';
import UserStatus from './TogelButton/UserStatus';

function Webhook() {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const [webhook, setWebhook] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  useEffect(() => {
    const fetchWebhooks = async () => {
      try {
        const response = await ViewTradingServices.getAllWebhooks();
        console.log(response)
        setWebhook(response?.data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching Webhooks:', error);
        setLoading(false);
      }
    };

    fetchWebhooks();
  }, []);

  const handleEditDetails = (help) => {
    setSelectedEdit(help);
    setIsEditModalOpen(true);
    toggleActionMenu(null);
  };

  const handleDelete = (help) => {
    setSelectedEdit(help);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
    setSelectedEdit(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>
          Webhook List <span className="badge bg-orange"></span>
        </h2>
        <div className="container-box-top-header-right">
          <a className="round-add-btn" href="/admin/add-webhook">
            <img src="img/plus.svg" alt="Add web" />
          </a>
        </div>
      </div>
      <div className="container-box px-0 pt-2">
        <div className="container-box-inner">
          <table
            id="example"
            className="table table-striped"
            style={{ width: '100%' }}
          >
            <thead>
              <tr>
                <th>#</th>
                <th>Scanner Type</th>
                <th>URL</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {webhook?.length > 0 ? (
                webhook.map((web, index) => (
                  <tr key={web._id}>
                    <td>{index + 1}</td>
                    <td>{web.scannerType}</td>
                    <td className="url-cell">
                      <span>{web.url}</span>
                      <button
                        onClick={() => {
                          navigator.clipboard.writeText(web.url);
                          setCopiedIndex(index); // mark this row as copied
                          setTimeout(() => setCopiedIndex(null), 2000); // hide after 2s
                        }}
                        className="ml-2 copy-btn"
                        title="Copy URL"
                      >
                        <i className="fa fa-copy"></i>
                      </button>
                      {copiedIndex === index && <span className="copied-text">Copied!</span>}
                    </td>

                  
                    <td>
                      <div className="action_toggle_outer">
                        <button
                          className="action_toggle"
                          onClick={() => toggleActionMenu(index)}
                        >
                          <i className="fa fa-ellipsis-v" />
                        </button>
                        {activeIndex === index && (
                          <div className="action_toggle_content product-edit show d-block">
                            <ul className="list-unstyled">
                              <li><button className="close_toggle" onClick={() => toggleActionMenu(null)}><i className="fa fa-close" /></button></li>
                             
                              <li><button className="reject" onClick={() => handleDelete(web)}>Delete</button></li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No Record Found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={closeEditModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <WebhookUpdate web={selectedEdit} closeModal={closeEditModal} />
      </Modal>
      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={closeDeleteModal}
        contentLabel="Delete Confirmation"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <DeleteButton data={selectedEdit} page="web" closeModal={closeDeleteModal} />
      </Modal>
    </div>
  );
}

export default Webhook;
